// removed by extract-text-webpack-plugin
module.exports = {"container":"AlexaDisconnectModal-container","title":"AlexaDisconnectModal-title","body":"AlexaDisconnectModal-body"};